module.exports = __webpack_public_path__ + "static/media/search.250d6509.svg";